var XPortal = XPortal || {};
XPortal.Multiline =
{
    ControlSelector: ".form-control-textarea",
    Init: function (container) {
        var self = this;
        container = container ? container : $(XPortal.Main.DetialFormSelector);
        var modelName = XPortal.Store.getModelName(container[0].id);
        container.find(self.ControlSelector).each(function () {
            self.initFor(modelName,$(this));
        });
    },
    initFor: function (modelName, el, isInlineEditor = false) {
        const sttgs = XPortal.Main.GetSettingsFor(el);
        el.change(function () {            
            XPortal.DefaultEditor.SetModification(el);
            if (!isInlineEditor) {
                el.trigger("dispatchFieldEvent");
            }            
        });
        el.bind("dispatchFieldEvent", function (e) {
            XPortal.Store.FieldEvent(el[0], el.val(), modelName, sttgs);            
        });
        XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: el },            
            (value) => !XPortal.DefaultEditor.IsModified(el) ? el.val(value) : false,
            (value) => el ? el.val() : false
        );
    }
};